import { useState, useEffect } from "react";
import { decode } from "universal-base64";
import clsx from "clsx";

import {
  Plate,
  createPlateUI,
  createAlignPlugin,
  ELEMENT_H1,
  ELEMENT_H2,
  ELEMENT_H3,
  ELEMENT_H4,
  ELEMENT_H5,
  ELEMENT_H6,
  ELEMENT_PARAGRAPH,
  ELEMENT_LI,
  createPlugins,
  createParagraphPlugin,
  createBlockquotePlugin,
  createTodoListPlugin,
  createHeadingPlugin,
  createImagePlugin,
  createHorizontalRulePlugin,
  createLinkPlugin,
  createListPlugin,
  createTablePlugin,
  createMediaEmbedPlugin,
  createCodeBlockPlugin,
  createBoldPlugin,
  createCodePlugin,
  createItalicPlugin,
  createHighlightPlugin,
  createUnderlinePlugin,
  createStrikethroughPlugin,
  createSubscriptPlugin,
  createSuperscriptPlugin,
  createFontBackgroundColorPlugin,
  createFontColorPlugin,
  createFontSizePlugin,
  createFontWeightPlugin,
  createKbdPlugin,
  createNodeIdPlugin,
  createComboboxPlugin,
  createMentionPlugin,
  createDeserializeMdPlugin,
  createDeserializeCsvPlugin,
  createDeserializeDocxPlugin,
  // createJuicePlugin,
  createFontFamilyPlugin,
  createIndentPlugin,
  getPlateActions,
} from "@udecode/plate";

function MobileReader({ value }) {
  const [initialState, setInitialState] = useState();
  const { resetEditor } = getPlateActions("mini");
  let components = createPlateUI();

  const plugins = createPlugins(
    [
      createParagraphPlugin(),
      createBlockquotePlugin(),
      createTodoListPlugin(),
      createHeadingPlugin(),
      createImagePlugin(),
      createHorizontalRulePlugin(),
      createLinkPlugin(),
      createListPlugin(),
      createTablePlugin(),
      createMediaEmbedPlugin(),
      createCodeBlockPlugin(),
      createBoldPlugin(),
      createCodePlugin(),
      createItalicPlugin(),
      createHighlightPlugin(),
      createUnderlinePlugin(),
      createStrikethroughPlugin(),
      createSubscriptPlugin(),
      createSuperscriptPlugin(),
      createFontBackgroundColorPlugin(),
      createFontFamilyPlugin(),
      createFontColorPlugin(),
      createFontSizePlugin(),
      createFontWeightPlugin(),
      createKbdPlugin(),
      createNodeIdPlugin(),
      createComboboxPlugin(),
      createMentionPlugin(),
      createDeserializeMdPlugin(),
      createDeserializeCsvPlugin(),
      createDeserializeDocxPlugin(),
      // createJuicePlugin(),
      createAlignPlugin({
        inject: {
          props: {
            validTypes: [
              ELEMENT_PARAGRAPH,
              ELEMENT_H1,
              ELEMENT_H2,
              ELEMENT_H3,
              ELEMENT_H4,
              ELEMENT_H5,
              ELEMENT_H6,
            ],
          },
        },
      }),
      createIndentPlugin({
        inject: {
          props: {
            validTypes: [ELEMENT_PARAGRAPH, ELEMENT_H1, ELEMENT_LI],
          },
        },
      }),
    ],
    {
      components,
    }
  );

  const editableProps = {
    placeholder: "Type…",
    style: {
      padding: "2px",
    },
    readOnly: true,
  };

  useEffect(() => {
    if (value) {
      try {
        const decoded = decode(value);
        setInitialState(JSON.parse(decoded));
      } catch (error) {
        setInitialState(JSON.parse(value));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  useEffect(() => {
    if (initialState) {
      resetEditor();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialState]);

  return (
    <div
      // className="prose-sm overflow-y-auto max-w-none prose-hr:border-t prose-hr:border-black/80 prose-hr:!border-solid prose-headings:!text-sm prose-p:!text-xs"
      className={clsx(
        "!max-w-none",
        "prose-sm",
        "prose-p:!py-0 prose-headings:!text-sm prose-p:!text-xs",
        "prose-figure:m-0",
        "prose-hr:border-t prose-hr:border-black/80 prose-hr:!border-solid",
        "prose-table:!table-auto",
        "prose-table:!border prose-table:!border-black",
        "prose-tr:!border-y prose-tr:!border-black",
        "prose-td:!border-x prose-td:!border-black"
      )}
    >
      <Plate
        id="mini"
        editableProps={editableProps}
        plugins={plugins}
        initialValue={initialState}
      />
    </div>
  );
}

export default MobileReader;
